/* Nūvo — cart upsell one-tap add. Works in the cart drawer and on the /cart page.
   Adds via cart/add.js and re-renders the relevant sections (Dawn section rendering)
   so the item appears instantly. Delegated listener; guarded against double-init
   (the module renders in both the drawer and the cart page). */
(function () {
  'use strict';
  if (window.__nuvoXsellInit) return;
  window.__nuvoXsellInit = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function innerFrom(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  // Refresh the full /cart page in place. Returns true if it managed to update.
  function refreshCartPage(data) {
    if (!data || !data.sections) return false;
    var ok = false;

    var itemsEl = document.getElementById('main-cart-items');
    if (itemsEl && data.sections['main-cart-items']) {
      var itemsTarget = itemsEl.querySelector('.js-contents');
      var itemsSrc = innerFrom(data.sections['main-cart-items'], '.js-contents');
      if (itemsTarget && itemsSrc != null) { itemsTarget.innerHTML = itemsSrc; ok = true; }
    }

    var footEl = document.getElementById('main-cart-footer');
    if (footEl && data.sections['main-cart-footer']) {
      var footTarget = footEl.querySelector('.js-contents');
      var footSrc = innerFrom(data.sections['main-cart-footer'], '.js-contents');
      if (footTarget && footSrc != null) { footTarget.innerHTML = footSrc; ok = true; }
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections['cart-icon-bubble']) {
      var bubbleSrc = innerFrom(data.sections['cart-icon-bubble'], '.shopify-section');
      bubble.innerHTML = bubbleSrc != null ? bubbleSrc : data.sections['cart-icon-bubble'];
    }

    // Drop the empty state if the cart was previously empty.
    if (ok) {
      var ci = document.querySelector('cart-items');
      if (ci) ci.classList.remove('is-empty');
    }
    return ok;
  }

  function addFromButton(btn) {
    var id = btn.dataset.variantId;
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var onCartPage = document.getElementById('main-cart-items') != null;
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !onCartPage && drawer && typeof drawer.renderContents === 'function';

    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (useDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    } else if (onCartPage) {
      body.sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
      body.sections_url = root() + 'cart';
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var data = {};
          try { data = JSON.parse(text); } catch (e) { /* non-JSON */ }
          if (!res.ok) {
            throw new Error(
              data.description ||
              (res.status === 429 ? 'Busy right now — please try again in a moment.' : 'Sorry, that could not be added.')
            );
          }
          return data;
        });
      })
      .then(function (data) {
        btn.classList.remove('is-loading');
        if (useDrawer && data.sections) {
          drawer.renderContents(data);
          if (typeof drawer.open === 'function') drawer.open();
        } else if (onCartPage) {
          if (!refreshCartPage(data)) window.location.reload();
        } else {
          window.location.href = root() + 'cart';
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (window.console) console.warn('Nūvo cart upsell:', err);
        if (document.getElementById('main-cart-items')) window.location.reload();
        else window.location.href = root() + 'cart';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nuvo-xsell__add');
    if (!btn || btn.tagName === 'A') return; // let "View" links navigate normally
    e.preventDefault();
    addFromButton(btn);
  });
})();
